module.exports = __webpack_public_path__ + "static/media/bordered-triangle-left-white.f2738bd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/bordered-triangle-left-white.svg
// module id = 1840
// module chunks = 0